import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Typography, Box, Button } from '@mui/material';
import ROUTE_PATH from '../../config/routes.config';
import EmptyLayout from '../../layout/empty.layout';
import notFoundImage from '../../assets/images/illustrations/illustration_404.svg';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const PageNotFoundView = () => {
  const pageTitle = '404 Not Found';

  const redirectTo = () => {
    window.location.href = ROUTE_PATH.DASHBOARD;
  };

  return (
    <EmptyLayout pageTitle={pageTitle}>
      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Sorry, page not found!
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            Sorry, we couldn&apos;t find the page you&apos;re looking for.
            Perhaps you&apos;ve mistyped the URL? Be sure to check your
            spelling.
          </Typography>

          <Box
            component="img"
            src={notFoundImage}
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button size="large" variant="contained" onClick={redirectTo}>
            Go to Home
          </Button>
        </StyledContent>
      </Container>
    </EmptyLayout>
  );
};

export default PageNotFoundView;
